import { render } from "./SignupSingleNewsletter.vue?vue&type=template&id=10e85002"
import script from "./SignupSingleNewsletter.vue?vue&type=script&lang=js"
export * from "./SignupSingleNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__